
class Auth{
    constructor(){
        const checkUser = localStorage.getItem('userDetails');
        this.isValid = checkUser!=null
    }

    login(cd){
        this.isValid = true;
        cd()
    }

    logout(cd){
        localStorage.removeItem('userDetails');
        this.isValid = false;
        cd()
    }

    isValid(){
        return this.isValid;
    }

    getToken(){
        let token = '';
        if(this.isValid){
            token = JSON.parse(localStorage.getItem('userDetails')).token;
        }else{
            this.logout(()=>{
                this.props.history.push('/login');
            })
        }
        return token
    }

}
export default new Auth();